// Tab rail shared by the Task Management pages (Dashboard / Projects / Task).
// Each tab is its own route, so the active tab is passed in explicitly by the
// page instead of being guessed from the URL.
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';

const TABS = [
    { key: 'dashboard', label: 'Dashboard', icon: 'mdi:view-dashboard-outline', path: '/society-portal/tasks/dashboard' },
    { key: 'projects', label: 'Projects', icon: 'hugeicons:folder-01', path: '/society-portal/tasks/projects' },
    { key: 'tasks', label: 'Task', icon: 'hugeicons:task-01', path: '/society-portal/tasks/list' },
];

const TaskTabs = ({ active }) => {
    const navigate = useNavigate();

    return (
        <div className="tw-bg-white tw-rounded-lg tw-shadow-sm tw-border tw-border-gray-100 tw-mb-4 tw-flex tw-items-center tw-gap-1 tw-px-2 tw-overflow-x-auto">
            {TABS.map((tab) => {
                const isActive = tab.key === active;
                return (
                    <button
                        key={tab.key}
                        onClick={() => !isActive && navigate(tab.path)}
                        className={`tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-2.5 tw-text-sm tw-font-medium tw-whitespace-nowrap tw-border-b-2 tw-transition-colors ${isActive
                            ? 'tw-border-blue-600 tw-text-blue-600'
                            : 'tw-border-transparent tw-text-gray-500 hover:tw-text-gray-700'}`}
                    >
                        <Icon icon={tab.icon} /> {tab.label}
                    </button>
                );
            })}
        </div>
    );
};

export default TaskTabs;
